// extracted by mini-css-extract-plugin
export default {"root":"ChaptersListMobile_root__Q49px"};